import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import SuperAdminRoute from "components/SuperAdminRoute";
import NotFound from "pages/NotFound";
import { useGoogleAnalytics } from "./hooks/useGoogleAnalytics";
import AnalyticsDashboard from './pages/analytics-dashboard';
import Login from './pages/login';
import CatalogViewer from './pages/catalog-viewer';
import AccountSettings from './pages/account-settings';
import EmbedSettings from './pages/embed-settings';
import Dashboard from './pages/dashboard';
import CatalogEditor from './pages/catalog-editor';
import Register from './pages/register';
import WidgetPreview from './pages/widget-preview';
import PDFUpload from './pages/pdf-upload';
import PDFLibrary from './pages/pdf-library';
import AcceptInvitation from './pages/accept-invitation';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/reset-password';
import EmbedViewer from './pages/embed-viewer';
import MenuSettings from './pages/menu-settings';
import CompanyCreate from './pages/company-create';

// Wrapper component to use Google Analytics inside Router context
function GoogleAnalyticsWrapper({ children }) {
  useGoogleAnalytics();
  return children;
}

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <GoogleAnalyticsWrapper>
          <ScrollToTop />
          <RouterRoutes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/accept-invitation" element={<AcceptInvitation />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/embed/:catalogId" element={<EmbedViewer />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/pdf-upload" element={<ProtectedRoute><PDFUpload /></ProtectedRoute>} />
            <Route path="/pdf-library" element={<ProtectedRoute><PDFLibrary /></ProtectedRoute>} />
            <Route path="/catalog-editor" element={<ProtectedRoute><CatalogEditor /></ProtectedRoute>} />
            <Route path="/catalog-viewer" element={<ProtectedRoute><CatalogViewer /></ProtectedRoute>} />
            <Route path="/analytics-dashboard" element={<ProtectedRoute><AnalyticsDashboard /></ProtectedRoute>} />
            <Route path="/account-settings" element={<ProtectedRoute><AccountSettings /></ProtectedRoute>} />
            <Route path="/embed-settings" element={<ProtectedRoute><EmbedSettings /></ProtectedRoute>} />
            <Route path="/embed-settings/:catalogId" element={<ProtectedRoute><EmbedSettings /></ProtectedRoute>} />
            <Route path="/menu-settings" element={<ProtectedRoute><MenuSettings /></ProtectedRoute>} />
            <Route path="/company-create" element={<ProtectedRoute><SuperAdminRoute><CompanyCreate /></SuperAdminRoute></ProtectedRoute>} />
            <Route path="/widget" element={<WidgetPreview />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </GoogleAnalyticsWrapper>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
